import(/* webpackMode: "eager" */ "/opt/render/project/src/apps/embedded-app/src/app/v1/layout.tsx");
